import l from"@emotion/styled";const o=l.div`
  label: radio-group;
  display: inline-flex;
  row-gap: 4px;
  flex-direction: column;
`;export{o as default};
